import { inquiryPurposeLabel } from './purpose.js';
/**
 * La **contre-visite** (#321, Q5) : une nouvelle demande dérivée d'un premier contrôle, sur le même
 * lieu. Elle garde le lien vers la première demande de la chaîne (`Inquiry.follow_up_of_id`) et son
 * **rang** (`follow_up_rank` : 1, 2…), écrit une fois à la création.
 *
 * ⚠️ **Le rang vient de la colonne, jamais de la référence** (M1) : « -CV » se propose à la
 * création, puis reste du texte libre que personne ne relit.
 */
/**
 * Le type affiché d'une demande : « Vente », puis « Vente Contre-visite », « Vente Contre-visite
 * 2 »… — dans les listes du bureau, sur la tablette, dans le CSV et dans le rapport.
 */
export function counterVisitLabel(purpose, rank) {
    const type = inquiryPurposeLabel(purpose);
    if (rank === null)
        return type;
    const visit = rank === 1 ? 'Contre-visite' : `Contre-visite ${String(rank)}`;
    return type === null ? visit : `${type} ${visit}`;
}
/** La référence proposée à la création : « <réf>-CV », puis « <réf>-CV2 »… `null` sans référence. */
export function counterVisitReference(reference, rank) {
    if (reference === null)
        return null;
    return rank === 1 ? `${reference}-CV` : `${reference}-CV${String(rank)}`;
}
//# sourceMappingURL=counter-visit.js.map